import { render, staticRenderFns } from "./SpecItemNormal.vue?vue&type=template&id=fdbe4ce8&scoped=true&"
import script from "./SpecItemNormal.vue?vue&type=script&lang=js&"
export * from "./SpecItemNormal.vue?vue&type=script&lang=js&"
import style0 from "./SpecItemNormal.vue?vue&type=style&index=0&id=fdbe4ce8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdbe4ce8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data2/workspace/sc-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fdbe4ce8')) {
      api.createRecord('fdbe4ce8', component.options)
    } else {
      api.reload('fdbe4ce8', component.options)
    }
    module.hot.accept("./SpecItemNormal.vue?vue&type=template&id=fdbe4ce8&scoped=true&", function () {
      api.rerender('fdbe4ce8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/seller/publishGoods/components/SpecItemNormal.vue"
export default component.exports